import { render, staticRenderFns } from "./commentBox.vue?vue&type=template&id=51fdf770&scoped=true&"
import script from "./commentBox.vue?vue&type=script&lang=js&"
export * from "./commentBox.vue?vue&type=script&lang=js&"
import style0 from "./commentBox.vue?vue&type=style&index=0&id=51fdf770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fdf770",
  null
  
)

export default component.exports